/* eslint-disable @next/next/no-sync-scripts */
import { useMemo } from 'react'

import { LOCALE } from '@hhgtech/hhg-components/types'
import Head from 'next/head'

import { domainLocales } from 'domainLocales'
import { useCategory } from 'hooks/useCategory'
import { useGetEncodedGaId } from 'hooks/useGetClientGaId'
import { useIsMobile } from 'hooks/useIsMobile'
import { useRouterExtend } from 'hooks/useRouterExtend'
import { ENV, GA_TOKEN_COOKIE, PWT_ID } from 'interfaces/constants'
import {
  BOT_SLUGS_STILL_ENABLE_ADS,
  CATEGORIES_TO_DISABLE_ADS,
  HEALTH_TOOLS_SLUGS_STILL_ENABLE_ADS,
  PUBLISHER_ACCOUNT_ID,
  ADS_COMMON,
} from 'interfaces/constants/ads'

const PWTWrapper = ({ testAdpushup }: { testAdpushup?: boolean }) => {
  const isMobile = useIsMobile()
  const { locale, query } = useRouterExtend()
  const { gaId } = useGetEncodedGaId()
  // if (typeof isMobileCsr === 'undefined') return null
  const scriptUrl = useMemo(() => {
    const pwtv = query.pwtv || ''
    const url = `//ads.pubmatic.com/AdServer/js/pwt/${PUBLISHER_ACCOUNT_ID}/${
      isMobile ? PWT_ID[locale].mobile : PWT_ID[locale].desktop
    }`
    let profileVersionId = ''
    if (pwtv) {
      profileVersionId = '/' + pwtv
    }
    return url + profileVersionId + '/pwt.js'
  }, [isMobile, query])

  return (
    /* render skinner ads */
    <>
      <script
        async
        dangerouslySetInnerHTML={{
          __html: `
          var getCookie = (name) => document.cookie.split('; ').reduce((r, v) => {
            const parts = v.split('='); return parts[0] === name ? decodeURIComponent(parts[1]) : r
          }, '')
          const gaId = (getCookie("${GA_TOKEN_COOKIE}") || '').replace(/GA1.[123]./g, '')

          window.getFpdDataFromPublisher = function() {
            return {
                customFpd: {
                    user: {
                        ext: {
                            eids: [{
                                source: "hellohealthgroup.com",
                                uids: [{
                                    id: gaId || '',
                                    atype: 1
                                }]
                            }]
                        }
                    }
                }
            };
          };

          document.addEventListener('DOMContentLoaded', function() {
            const script = document.createElement('script')
            script.src = "${scriptUrl}"
            script.async = true
            document.head.appendChild(script)

            const preSetupScript = document.createElement('script')
            preSetupScript.type = 'text/javascript'
            preSetupScript.async = true
            preSetupScript.innerHTML = \`
              window._mgPubmaticExists = true;
              var PWT={}; //Initialize Namespace
              var googletag = googletag || {};
              googletag.cmd = googletag.cmd || [];
              var gptRan = false;
              PWT.jsLoaded = function(){ //PubMatic pwt.js on load callback is used to load GPT
                  loadGPT();
              };
              var loadGPT = function(afterPWTRun) {
                  // Check the gptRan flag
                  if (!gptRan) {
                      gptRan = true;
                      var gads = document.createElement('script');
                      var useSSL = 'https:' == document.location.protocol;
                      gads.src = (useSSL ? 'https:' : 'http:') + '//securepubads.g.doubleclick.net/tag/js/gpt.js';  //render skinner ads
                      var node = document.getElementsByTagName('script')[0];
                      node.parentNode.insertBefore(gads, node);
                  }
              };
              // Failsafe to call gpt
              setTimeout(loadGPT, 500);
            \`
            document.head.appendChild(preSetupScript)
          }, false);
        `,
        }}
      />
      <Head>
        {/* <link rel="preload" href={scriptUrl} as="script" /> */}
        {/* <link
          rel="preload"
          href="https://securepubads.g.doubleclick.net/tag/js/gpt.js"
          as="script"
        /> */}
        {/* <script
          key="pwt-pre-setup"
          type="text/javascript"
          async
          dangerouslySetInnerHTML={{
            __html: `
              window._mgPubmaticExists = true;
              var PWT={}; //Initialize Namespace
              var googletag = googletag || {};
              googletag.cmd = googletag.cmd || [];
              var gptRan = false;
              PWT.jsLoaded = function(){ //PubMatic pwt.js on load callback is used to load GPT
                  loadGPT();
              };
              var loadGPT = function(afterPWTRun) {
                  // Check the gptRan flag
                  if (!gptRan) {
                      gptRan = true;
                      var gads = document.createElement('script');
                      var useSSL = 'https:' == document.location.protocol;
                      gads.src = (useSSL ? 'https:' : 'http:') + '//securepubads.g.doubleclick.net/tag/js/gpt.js';
                      var node = document.getElementsByTagName('script')[0];
                      node.parentNode.insertBefore(gads, node);
                  }
              };
              // Failsafe to call gpt
              setTimeout(loadGPT, 500);
            `,
          }}
        ></script>
        <script
          key="pwt-script"
          src={scriptUrl}
          async
          type="text/javascript"
        ></script> */}
        {testAdpushup && (
          <>
            <script
              async
              data-cfasync="false"
              type="text/javascript"
              dangerouslySetInnerHTML={{
                __html: `(function(w, d) { var s = d.createElement('script'); s.src = '//cdn.adpushup.com/45367/adpushup.js'; s.crossOrigin='anonymous'; s.type = 'text/javascript'; s.async = true; (d.getElementsByTagName('head')[0] || d.getElementsByTagName('body')[0]).appendChild(s); w.adpushup = w.adpushup || {que:[]}; })(window, document);`,
              }}
            />
            <script
              async
              type="text/javascript"
              dangerouslySetInnerHTML={{
                __html: `!function(w,d){
              var adpushup = w.adpushup = w.adpushup || {que:[]};
              adpushup.que.push(function(){
              adpushup.init();
              })
              }(window, document);`,
              }}
            ></script>
          </>
        )}
      </Head>
      {gaId && (
        <iframe
          src={`https://ads.pubmatic.com/AdServer/js/user_sync.html?p=${
            ADS_COMMON.PUBLISHER_ACCOUNT_ID
          }&gdpr=&gdpr_consent=&userIdMacro=(PM_UID)&predirect=${encodeURIComponent(
            `${ENV.NEXT_PUBLIC_THE_TRADE_DESK_API}api/publisher?partner=pubmatic&cookieid=(PM_UID)&hhgGaClientId=${gaId}&domain=${domainLocales[locale]}`,
          )}`}
          title="iframe_cookie_sync"
          width="1"
          height="0"
          className="block"
        ></iframe>
      )}
    </>
  )
}
const PWTWrapper1 = ({ testAdpushup }: { testAdpushup?: boolean }) => {
  const { locale, asPath } = useRouterExtend()
  const { isPregnancy, isParenting, isHealth } = useCategory()
  // if (typeof isMobileCsr === 'undefined') return null

  if (
    (locale === LOCALE.Indonesia && (isPregnancy || isParenting)) ||
    (locale === LOCALE.Taiwan && isHealth)
  ) {
    return (
      <Head>
        <script
          defer
          src="https://securepubads.g.doubleclick.net/tag/js/gpt.js"
        ></script>
      </Head>
    )
  }
  return (locale === LOCALE.Taiwan && isHealth) ||
    (CATEGORIES_TO_DISABLE_ADS[locale] || []).find((i: string) =>
      asPath.startsWith(i),
    ) ||
    (asPath.startsWith('/health-tools/') &&
      !(HEALTH_TOOLS_SLUGS_STILL_ENABLE_ADS[locale] || []).find((i) =>
        encodeURIComponent(decodeURIComponent(asPath)).startsWith(
          encodeURIComponent(i),
        ),
      )) ||
    (asPath.startsWith('/bot/') &&
      !(BOT_SLUGS_STILL_ENABLE_ADS[locale] || []).find((i) =>
        encodeURIComponent(decodeURIComponent(asPath)).startsWith(
          encodeURIComponent(i),
        ),
      )) ? null : (
    <PWTWrapper testAdpushup={testAdpushup} />
  )
}

export default PWTWrapper1
